import React from 'react';
import { MdLogout } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { ReadOnlyBanner } from '../util/ReadOnlyBanner';
import { useFormContext } from '../../context/FormContext';
import Session from '../auth/Session';

// Wraps every step with progress bar, card content area, and 'Need assistance?' footer
export function SignupLayout({ currentStep = 1, totalSteps = 3, stepLabel = '', children, showProgress = true, }) {
    const { resetForm } = useFormContext();
    const pct = Math.round((currentStep / totalSteps) * 100);

    const isLoggedIn = !!Session.getToken();

    const roles = Session.getRole() || '';
    const isAdminCSR = roles.includes('Admin') || roles.includes('CSR');
    
    const handleLogout = () => {
        Session.removeUserSession();
        resetForm();
        window.location.href = '/login';
    };

    return (
        <div className="signup-shell">
            {isLoggedIn && !isAdminCSR && (
                <header className="dashboard-header">
                    <button className="dashboard__logout" onClick={handleLogout}>
                        Log out
                        <MdLogout size={16} style={{ marginLeft: '4px' }} />
                    </button>
                </header>
            )}
            {/* -- Card -- */}
            <main className="signup-card">
                <ReadOnlyBanner />

                {/* Progress strip */}
                {showProgress && (
                    <div className="signup-progress">
                        <div className="signup-progress__meta">
                            <span className="signup-progress__step">Step {currentStep} of {totalSteps}</span>
                            <span className="signup-progress__label">{stepLabel}</span>
                        </div>
                        <div className="signup-progress__track">
                            <div
                                className="signup-progress__fill"
                                style={{ width: `${pct}%` }}
                            />
                        </div>
                    </div>
                )}

                {/* Page content */}
                <div className="signup-content">
                    {children}
                </div>
            </main>

            {/* -- Footer -- */}
            <footer className="signup-footer">
                <p>Need assistance?</p>
                <p>Call us at <a href="tel:8772695422">877-269-5422</a> to connect.</p>
            </footer>
        </div>
    );
}